// Inspired by https://stackoverflow.com/questions/996505/lru-cache-implementation-in-javascript with added types
export class LRU<K, V> {
  private cache: Map<K, V>;

  constructor(private max: number) {
    this.max = max;
    this.cache = new Map<K, V>();
  }

  get(key: K) {
    const item = this.cache.get(key);
    if (item) {
      // refresh key
      this.cache.delete(key);
      this.cache.set(key, item);
    }
    return item;
  }

  set(key: K, value: V) {
    // refresh key
    if (this.cache.has(key)) {
      this.cache.delete(key);
    } else if (this.cache.size == this.max) {
      this.cache.delete(this.first());
    }
    this.cache.set(key, value);
  }

  // First will always return the oldest key
  private first() {
    return this.cache.keys().next().value;
  }
}
